const CSS_VARIABLES = {
  '--text-color': 'var(--s-cape-text-color, #333)',

  '--primary-color': 'var(--s-cape-primary-color, #27ae60)',
  '--primary-color-hover': 'var(--s-cape-primary-color-hover, #198e4a)',
  '--primary-text-color': 'var(--s-cape-primary-text-color, #fff)',

  '--secondary-color': 'var(--s-cape-secondary-color, #032e61)',
  '--secondary-color-hover': 'var(--s-cape-secondary-color-hover, #0b3f7d)',
  '--secondary-text-color': 'var(--s-cape-secondary-text-color, #fff)',

  '--card-header-bg': 'var(--s-cape-card-header-bg, #f3f4f6)',
  '--card-header-border': 'var(--s-cape-card-header-border, #e5e5e5)',
  '--card-header-text-color': 'var(--s-cape-card-header-text-color, #333)',

  // Calendar style variables
  '--calendar-active-color': 'var(--s-cape-calendar-active-color, var(--primary-color))',
  '--calendar-active-text-color': 'var(--s-cape-calendar-active-text-color, #fff)',
  '--calendar-inactive-day-text-color': 'var(--s-cape-calendar-inactive-day-text-color, #aaa)',

  // Button style variables
  '--button-primary-color': 'var(--s-cape-button-primary-color, var(--primary-color))',
  '--button-primary-color-hover': 'var(--s-cape-button-primary-color-hover, var(--primary-color-hover))',
  '--button-primary-text-color': 'var(--s-cape-button-primary-text-color, #fff)',
  '--button-primary-text-color-hover': 'var(--s-cape-button-primary-text-color-hover, #fff)',

  '--button-secondary-color': 'var(--s-cape-button-secondary-color, var(--secondary-color))',
  '--button-secondary-color-hover': 'var(--s-cape-button-secondary-color-hover, var(--secondary-color-hover))',
  '--button-secondary-text-color': 'var(--s-cape-button-secondary-text-color, #fff)',
  '--button-secondary-text-color-hover': 'var(--s-cape-button-secondary-text-color-hover, #fff)',

  '--button-mute-color': 'var(--s-cape-button-mute-color, #f6f7f8)',
  '--button-mute-color-hover': 'var(--s-cape-button-mute-color, #e1e2e3)',
  '--button-mute-text-color': 'var(--s-cape-button-mute-text-color, #333)',
  '--button-mute-text-color-hover': 'var(--s-cape-button-mute-text-color-hover, #111)',

  '--button-link-color': 'var(--s-cape-button-link-color, #fff)',
  '--button-link-color-hover': 'var(--s-cape-button-link-color-hover, #eee)',
  '--button-link-text-color': 'var(--s-cape-button-link-text-color, #333)',
  '--button-link-text-color-hover': 'var(--s-cape-button-link-text-color-hover, #111)',

  '--radio-label-accent-color': 'var(--s-cape-radio-label-accent-color, var(--primary-color))',

  '--steps-bg': 'var(--s-cape-steps-bg, #f3f4f6)',
  '--steps-text-color': 'var(--s-cape-steps-text-color, #333)',
  '--steps-active-bg': 'var(--s-cape-steps-active-bg, #032e61)',
  '--steps-active-text-color': 'var(--s-cape-steps-active-text-color, #fff)',

  '--alert-info-bg': 'var(--s-cape-alert-info-bg, #f3f4f6)',
  '--alert-info-text-color': 'var(--s-cape-alert-info-text-color, #333)',

  '--alert-danger-bg': 'var(--s-cape-alert-danger-bg, #c10007)',
  '--alert-danger-text-color': 'var(--s-cape-alert-danger-text-color, #fff)',

  '--alert-success-bg': 'var(--s-cape-alert-success-bg, #5ea50a)',
  '--alert-success-text-color': 'var(--s-cape-alert-success-text-color, #fff)',

  '--text-base': '16px',
  '--text-lg': '18px',
  '--text-sm': '14px',
  '--text-xl': '20px',
  '--text-2xl': '24px',

  '--spacing': '4px',

  '--container-lg': '512px',
} as const;

export default CSS_VARIABLES;
